export const modulesList = {
  default: {
    gis: ["Map", "Book", "Chart"],
    mtp: ["Scenario Modelling", "Traffic Counts", "PT Registry"],
    other: ["Situation center"]
  },
  chelyabinsk: {
    gis: ["Map", "Book", "Chart"],
    other: ["Situation center"]
  },
  tagil: {
    gis: ["Map", "Book", "Chart"],
    other: ["Situation center"]
  }
};
